<template>
  <div id="userLayout" :class="['user-layout-wrapper', isMobile && 'mobile']">
    <!-- <div class="container" :style="{backgroundImage:'url('+ api_url + 'pc/'+ newold + '/&fileName=background.svg)'}"> -->
    <div class="container">
      <div class="con_bg">
        <img :src="bgImg" alt="">
      </div>
      <div class="containerCenter" id="containerCenter" >
        <div class="top">
          <img :src="img" class="logo" alt="logo" />
          <span class="title">安联云管家</span><img />
        </div>
        <router-view />
        <div class="bottom">
          <div style="font-weight: 700; font-size: 16px">手机扫一扫下载安装APP</div>
          <div class="photo">
            <div class="left">
              <!-- '/file/file/last_app_qr?type=2'  -->
              <img :src="imgUrl1" />
              <div style="font-weight: 700; margin-top: 10px">安卓 1.6.3</div>
            </div>
            <div class="right">
              <!-- imgUrl2 -->
              <!-- 'http://122.227.208.114:98/file/file/last_app_qr?type=3' -->
              <img :src="imgUrl2" onerror="this.style.display='none',this.onerror=null,this.index=1" @error="errImg" />
              <div style="font-weight: 700; margin-top: 10px" v-if="typeIdex != 3">IOS{{ typeIdex }}</div>
            </div>
          </div>
          <!-- <router-link :to="{ name: 'privacy' }" style="color: #fff;">隐私政策</router-link> -->
          <!-- <a @click="getPrivacy" style="color: #fff;" target="_blank">隐私政策</a> -->
        </div>
      </div>
    </div>
    <!-- <preview ref="preview" /> -->
  </div>
</template>

<script>
import { sys_status_config } from '@/api/activiti'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
import { last_app_qr } from '@/api/login'
import api from './index'
import { previewFileLists } from '@/utils/preview.js'
// import preview from '@/components/module/prview'
import { deviceMixin } from '@/store/device-mixin'
export default {
  name: 'UserLayout',
  components: {
    // preview,
  },
  data() {
    return {
      // responseAnd: '',
      // responseIos: '',
      bgImg: '',
      typeIdex: undefined,
      img: '',
      imgUrl1: process.env.VUE_APP_API_BASE_URL + '/file/file/last_app_qr?type=2',
      imgUrl2: process.env.VUE_APP_API_BASE_URL + '/file/file/last_app_qr?type=3',
    }
  },
  mixins: [deviceMixin],
  beforeCreate() {
    var t = this.$route.query.t
    if (t) {
      window.sessionStorage.setItem('ot', t)
    }
  },
  created() {
   

  },
  mounted() {
     //获得主题
    sys_status_config().then((res)=> {
        if(res.code == 200) {
          var value = res.data.filePathName
          if(res.data.activeColor) {
            window.localStorage.setItem('loginColor', res.data.activeColor)
          } else {
            window.localStorage.setItem('loginColor', '')
          }
          this.$nextTick(() => {
            var time = new Date().getTime()
            this.bgImg = process.env.VUE_APP_API_BASE_URL + '/file//file/pre_static' + '?path=/pc/'+ value + '/&fileName=login.png&time=' + time
            this.img = process.env.VUE_APP_API_BASE_URL + '/file//file/pre_static' + '?path=/pc/'+ value + '/&fileName=logo.png&time=' + time
          })
          // document.getElementById('containerCenter').style.background = bgImg
          console.log(this.bgImg,this.img , 'this.img =================')
        } else {
          this.$message.error(res.msg)

        }
        })
    document.body.classList.add('userLayout')
    this.$nextTick(() => {
      if (window.sessionStorage.getItem('ot')) {
        var ot = window.sessionStorage.getItem('ot')
      } else {
        var ot = window.localStorage.getItem('ot')
      }
      console.log(ot, 'ot==================')
      storage.set(ACCESS_TOKEN, ot, 12 * 60 * 60 * 1000)
      this.$store.commit('SET_TOKEN', ot)
      setTimeout(() => {
        this.$router.push({
          path: '/dashboard/weclome',
        })
      }, 2000);
    })
    console.log(this.$route.query.t, 'this.$route.query.t=========')
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  },
  methods: {
    getPrivacy() {
      this.$router.push({
        path: '/privacy'
      })

    },
    errImg() {
      this.$nextTick(() => {
        this.typeIdex = 3
      })
    },
    // 		 show_img(idx, imgs) {
    //   var row = {
    //     index: idx,
    //     imgs: imgs,
    //   }
    //   this.$refs.preview.show(row)
    // },
    // getData() {
    // 	last_app_qr({
    // 		type: 2
    // 	}).then(res1 => {
    // 		previewFileLists(res1.data).then((res) => {
    //            this.responseAnd = res1
    //           })

    // 		console.log(this.responseAnd,'111111111111111111111')
    // 	})
    // 	last_app_qr({
    // 		type: 3
    // 	}).then(res2 => {
    // 		 previewFileLists(res2.data).then((res) => {
    //           this.responseIos = res2
    //           })

    // 		console.log(this.responseIos, '2222222222222222222222222222')
    // 	})

    // }
  },
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100vh;
  width: 100vw;

  .container {
    width: 100vw;
    height: 100vh;
    // background: #f0f2f5 url('../assets/login_img/login.jpg') no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .con_bg{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
      width: 100%;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .containerCenter {
      width: 400px;
      float: left;
      background: #fff;
      border-radius: 10px;
      padding: 30px 25px;
      box-sizing: border-box;
      box-shadow: 1px 1px 5px 2px #3e5bd0;
      z-index: 2;
    }


    .top {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .logo {
        height: 40px;
        vertical-align: top;
        margin-right: 16px;
        border-style: none;
      }

      .title {
        font-size: 28px;
        font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
        font-weight: 600;
        position: relative;
        top: 2px;
      }
    }

    .bottom {
      width: 100%;
      margin: 0 auto;
      text-align: center;
      // align-items: center;
      margin-top: 50px;

      .photo {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;

        img {
          padding: 5px;
          background-color: #fff;
          width: 130px;
        }
      }
    }

  }
}
</style>
